import React from "react";
import { Form, Field } from "react-final-form";
import { TextInput } from "@pickit/pickit-components";
import "./restorePassword.scss";
import { ReactComponent as Logo } from "./../../../assets/canguroLogo.svg";
import { ReactComponent as LogoText } from "./../../../assets/pickers.svg";
import { ReactComponent as OkeyIcon } from "./../../../assets/ok.svg";
import { ReactComponent as EmptyIcon } from "./../../../assets/void-check.svg";
import { ReactComponent as InfoIcon } from "./../../../assets/Informacion.svg";
import useValidationSchema from "hooks/useValidationSchema";
import { RestoreEmailPasswordType, RestorePasswordType } from "./types";
import { VALIDATION_REGEX } from "utils/constants";
import classNames from "classnames";
import "./i18n";
import { useTranslation } from "react-i18next";

export const RestorePassword = ({
  validationSchema,
  isFetching,
  testId,
  onSubmit,
}: RestoreEmailPasswordType): JSX.Element => {
  const { t } = useTranslation("restorePassword");

  const passwordValidations = [
    {
      label: "passwordMinLength",
      validation: (value: string) => value?.length >= 8,
      id: "length",
    },
    {
      label: "upperCaseandLowerCase",
      validation: (value: string) => value?.match(VALIDATION_REGEX.regMayMin),
      id: "upper-lower-case",
    },
    {
      label: "numbersAndLeters",
      validation: (value: string) => value?.match(VALIDATION_REGEX.regLetNum),
      id: "numbers-letters",
    },
  ];

  return (
    <div className="background-login">
      <div className="login-logo-container">
        <Logo />
        <LogoText height={45} width={158} />
      </div>
      <Form
        onSubmit={(values: RestorePasswordType) => onSubmit(values.password)}
        validate={useValidationSchema(validationSchema)}
      >
        {({ handleSubmit, values, invalid }) => (
          <form className="login-form" onSubmit={handleSubmit}>
            <Field
              textType="password"
              name="password"
              id="password"
              label={t("newPassword")}
              component={TextInput}
              showClearIcon={false}
              maxLength={20}
              testId={`${testId}-password`}
            />
            <Field
              textType="password"
              name="confirmPassword"
              id="confirmPassword"
              showClearIcon={false}
              label={t("confirmNewPassword")}
              component={TextInput}
              maxLength={20}
              testId={`${testId}-confirm-password`}
            />

            <ul className="password-hints" data-testId={`${testId}-title-validations-password`}>
              {t("passwordMustHave")}
              {passwordValidations.map((item) => (
                <li
                  className="display-flex"
                  data-testId={`${testId}-validations-password`}
                >
                  {!values.password ? (
                    <EmptyIcon />
                  ) : item.validation(values.password) ? (
                    <OkeyIcon />
                  ) : (
                    <InfoIcon />
                  )}
                  <p
                    data-testId={`${testId}-error-validation-${item.id}`}
                    className={
                      item.validation(values?.password) ||
                      values?.password === undefined
                        ? ""
                        : "error-text"
                    }
                  >
                    {t(item.label)}
                  </p>
                </li>
              ))}
            </ul>
            <button
              className={classNames("login-button", {
                "button-disabled": invalid,
              })}
              disabled={isFetching || invalid}
              type="submit"
              name="button"
              data-testId={`${testId}-submit-button`}
            >
              <p
                className="login-init"
                data-testId={`${testId}-submit-button-label`}
              >
                {t("save")}
              </p>
            </button>
          </form>
        )}
      </Form>
    </div>
  );
};
export default RestorePassword;
